module.exports = __webpack_public_path__ + "static/media/extra-activities-secondary4.47d5175c.svg";